import { getImageUrl } from '../../../config/api';
import { isProductOutOfStock } from '../../../lib/utils/stock';
import { getDefaultOptionValueIds } from '../../../lib/utils/options';

export interface ProductCardData {
  id: string;
  name: string;
  imageUrl: string;
  price: number;
  originalPrice?: number;
  discountPercentage?: number;
  isFeatured?: boolean;
  isBestSeller?: boolean;
  isOutOfStock?: boolean;
  defaultVariantId?: string;
  hasMultipleVariants?: boolean;
  hasOptionGroups?: boolean;
  defaultOptionValueIds?: string[];
}

/**
 * Maps a storefront product (as returned by the products API) into the shape
 * expected by ProductSlider / ProductCard. Shared by the curated homepage
 * sliders (featured / on sale / best sellers) and the per-category sliders.
 */
export function mapProductToCard(product: any): ProductCardData {
  const maxDiscount = Math.max(
    ...((product.variants?.map((v: any) => v.discountPercentage) as number[]) || [0])
  );
  const price = product.minPrice ?? 0;

  return {
    id: product.id,
    name: product.name,
    imageUrl: getImageUrl(
      product.images?.find((img: any) => img.isMain)?.thumbnailUrl ||
        product.images?.find((img: any) => img.isMain)?.url ||
        product.images?.[0]?.thumbnailUrl ||
        product.images?.[0]?.url
    ),
    price,
    originalPrice: maxDiscount > 0 && price > 0 ? price / (1 - maxDiscount / 100) : undefined,
    discountPercentage: maxDiscount > 0 ? maxDiscount : undefined,
    isFeatured: product.isFeatured,
    isBestSeller: product.isBestSeller,
    isOutOfStock: isProductOutOfStock(product),
    defaultVariantId: product.defaultVariantId,
    hasMultipleVariants: (product.variants?.length ?? 0) > 1,
    hasOptionGroups: (product.optionGroups?.length ?? 0) > 0,
    defaultOptionValueIds: getDefaultOptionValueIds(product),
  };
}
